"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_PRODUCT_IN_LIST = exports.ANALYTICS_FAVORITES_REMOVE = exports.ANALYTICS_FAVORITES_ADD = void 0;
const MAX_PRODUCT_IN_LIST = exports.MAX_PRODUCT_IN_LIST = 100;
// Analytic events
const ANALYTICS_FAVORITES_ADD = exports.ANALYTICS_FAVORITES_ADD = 'favorites_add';
const ANALYTICS_FAVORITES_REMOVE = exports.ANALYTICS_FAVORITES_REMOVE = 'favorites_remove';
